import { useEffect, useState } from 'react';
import { apiClient } from '../../auth-lib';
import { useNavigate } from 'react-router-dom';
import OrgAdminLayout from '../components/OrgAdminLayout';
import { StatusPill, EmptyState, Table, useToast } from '../../design-system';
import '../styles/OrgAdminTasks.css';

function OrgAdminDeletedTasks() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    fetchDeletedTasks();
  }, []);

  const fetchDeletedTasks = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/tasks', { params: { deleted: 'true' } });
      setTasks(response.data);
    } catch (err) {
      toast.danger(err.response?.data?.error || 'Failed to load deleted tasks');
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (taskId) => {
    try {
      await apiClient.patch(`/api/tasks/${taskId}/restore`);
      setTasks((prev) => prev.filter((t) => t._id !== taskId));
      toast.success('Task restored');
    } catch (err) {
      toast.danger(err.response?.data?.error || 'Failed to restore task');
    }
  };

  const columns = [
    {
      key: 'taskNumber',
      header: 'ID',
      render: (t) => (t.taskNumber != null ? `TASK-${String(t.taskNumber).padStart(4, '0')}` : '-'),
    },
    {
      key: 'title',
      header: 'Task',
      render: (t) => (
        <button className="task-title-link" onClick={() => navigate(`/org-admin/tasks/${t._id}`)}>
          {t.title}
        </button>
      ),
    },
    { key: 'priority', header: 'Priority', render: (t) => <StatusPill status={t.priority} /> },
    { key: 'assignedTo', header: 'Assigned To', render: (t) => t.preparerId?.name || '-' },
    { key: 'deletedAt', header: 'Deleted', render: (t) => (t.deletedAt ? new Date(t.deletedAt).toLocaleString() : '-') },
    {
      key: 'actions',
      header: '',
      render: (t) => (
        <button className="action-link" onClick={() => handleRestore(t._id)}>
          Restore
        </button>
      ),
    },
  ];

  return (
    <OrgAdminLayout title="Deleted Tasks" subtitle="Recover tasks that were removed — nothing here is gone for good">
      <div className="tasks-management">
        {!loading && <p className="tasks-count">Showing {tasks.length} deleted task{tasks.length === 1 ? '' : 's'}</p>}

        {!loading && tasks.length === 0 ? (
          <EmptyState icon="🗑️" title="No deleted tasks" description="Tasks you delete will show up here, ready to restore." />
        ) : (
          <Table columns={columns} data={tasks} loading={loading} />
        )}
      </div>
    </OrgAdminLayout>
  );
}

export default OrgAdminDeletedTasks;
